import { render } from "./CustomDateFilter.vue?vue&type=template&id=6681a168&scoped=true"
import script from "./CustomDateFilter.vue?vue&type=script&lang=js"
export * from "./CustomDateFilter.vue?vue&type=script&lang=js"

import "./CustomDateFilter.vue?vue&type=style&index=0&id=6681a168&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6681a168"]])

export default __exports__